"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var material_1 = require("@mui/material");
var colors_1 = require("@mui/material/colors");
var react_1 = __importDefault(require("react"));
function ButtonComponent(props) {
    return (0, jsx_runtime_1.jsx)(material_1.Button, __assign({}, props, { children: props.children }));
}
var ButtonBase = react_1.default.forwardRef(function ButtonBase(props, ref) {
    return ((0, jsx_runtime_1.jsx)(material_1.Button, __assign({}, props, { ref: ref }, { children: props.children })));
});
var ButtonFilter = react_1.default.forwardRef(function ButtonFilter(props, ref) {
    return ((0, jsx_runtime_1.jsx)(material_1.Button, __assign({ sx: { borderColor: colors_1.grey[300], textTransform: 'none' } }, props, { ref: ref }, { children: props.children })));
});
ButtonComponent.ButtonComponent = ButtonComponent;
ButtonComponent.Filter = ButtonFilter;
ButtonComponent.Base = ButtonBase;
exports.default = ButtonComponent;
